/* @ngInject */
const axletreeFormat = (
  utils
) => {
  const self = {}

  self.server = (_axletree) => {
    const axletree = utils.copy(_axletree)

    axletree.expeditionDate = utils.date.stringToServer(axletree.expeditionDate)

    return axletree
  }

  self.user = (_axletree) => {
    const axletree = utils.copy(_axletree)

    axletree.expeditionDate = utils.date.timestampToString(axletree.expeditionDate)

    return axletree
  }

  return self
}
export default axletreeFormat



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/axletree/services/format.service.js